import { Box, Typography } from '@mui/material';

interface ChatInfoBoxProps {
  headline: string;
  text: string;
}

export const ChatInfoBox = ({ headline, text }: ChatInfoBoxProps) => {
  return (
    <Box style={{ padding: 16, backgroundColor: '#ddd', borderRadius: 20, display: 'inline' }}>
      <Typography fontWeight={'bold'} style={{ wordBreak: 'break-word', display: 'inline' }}>
        {headline}
      </Typography>
      {' - '}
      <Typography variant="body2" style={{ wordBreak: 'break-word', display: 'inline' }}>
        {text}
      </Typography>
    </Box>
  );
};
